<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="column">
    <h4>{{ appSdkIdLabel }}</h4>
    <strong>{{ providerAccount?.id }}</strong>
  </div>
  <button mat-raised-button (click)="toggleCodeSnippet()">
    {{ !showCodeSnippet ? getCodeSnippetLabel : hideCodeSnippetLabel }}
  </button>
</div>
@if (showCodeSnippet) {
  <div class="webchat-snippet">
    <code>
      <div class="button-wrapper">
        <button class="copy-button" (click)="copyToClipboard()">
          {{ copyToClipboardLabel }}
        </button>
      </div>
      <p #webchatSnippet>{{ injectBotonicSdk() }}</p>
    </code>
  </div>
}
